<template>
    <div>
        <mainone :mainonebread="mainonebread"></mainone>
        <div>
            <!--标题-->
            <div class="box">
                <!--内容-->
                <div class="box_content" id="switch">
                    <el-tabs v-model="activeName" @tab-change="handleClick">
                        <!-- 设备设置 -->
                        <el-tab-pane label="设备设置" name="1">
                            <setModelDevice />
                        </el-tab-pane>
                        <!-- 代理商设置 -->
                        <el-tab-pane label="代理商设置" name="2">
                            <setModelAgent />
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mainone from '@/components/Mainone'
import setModelDevice from './setModelDevice.vue'
import setModelAgent from './setModelAgent.vue'
import { defineComponent } from 'vue'
import axios from 'axios'

export default defineComponent({
    name: 'vdeviceSet',
    inject: ['reload'], //刷新引用
    data() {
        return {
            mainonebread: [
                {
                    name: '运营'
                },
                {
                    name: '权益会员'
                },
                {
                    name: '商家权益',
                    path: '/shopEquity'
                },
                {
                    name: '设备设置'
                }
            ], // 当前页-【面包屑导航】
            activeName: '1', //tabs标签-默认显示页

            mypowerlimits: JSON.parse(localStorage.getItem('powerlimits')) //获取权限
        }
    },
    methods: {
        handleClick(activename) {
            this.activeName = activename
        }
    },
    created() {
        if (localStorage.getItem('token') === null || !localStorage.getItem('token')) {
            this.$router.push('/').catch((error) => error)
        } else {
            this.handleClick(this.activeName)
        }
    },
    components: {
        mainone,
        setModelDevice,
        setModelAgent
    }
})
</script>
<style scoped>
.box {
    background-color: #ffffff;
    border-radius: 4px;
    color: #333333;
    padding: 10px 20px;
}

.box_content :deep(.el-form-item__error) {
    position: static !important;
}

.box_content :deep(.el-upload) {
    display: block !important;
}

.box_content {
    border-top: 0px solid #eeeeee;
}
</style>
